import { Button } from './ui'
export default function RequestError({ title = 'Unable to load this section', message, retry }: {
  title?: string; message: string; retry?: () => void
}) {
  return <div className="request-error" role="alert">
    <span className="request-error-mark" aria-hidden="true">!</span>
    <div className="grow"><strong>{title}</strong><p>{message}</p></div>
    {retry && <Button onClick={retry}>Try again</Button>}
  </div>
}
